import React from "react";
// import homeVideo from "../../../assets/videos/home.mp4";
import homeVideo2 from "../../../assets/videos/home2.webm";

function Welcome() {
  return (
    <div className="">
      <section className="leap-video-section mb-5">
        <video
          className="leap-w-full  leap-h-auto leap-object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={homeVideo2} type="video/webm" />
        </video>
      </section>
    </div>
  );
}

export default Welcome;
